import Vue from 'vue'

export default {
    UPDATE_QUOTES (state, value) {
        Vue.set(state, 'quotes', value);
    },
  SET_QUOTES (state, value) {
        this.commit('UPDATE_QUOTES', value);
    },
    SET_SELECTED_QUOTE (state,  value ) {
      Vue.set(state, 'selectedQuote', value);
    },
}



// WEBPACK FOOTER //
// ./src/store/modules/quotes/mutations.js